import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Table from "react-bootstrap/Table"
import { Badge } from "react-bootstrap"
import PageLayout from "../../../components/PageLayout"
import Footer from "../../../components/Footer"
import { Search } from "../../../components/Search"

import "bootstrap/dist/css/bootstrap.min.css"

import {
  content,
  schoolCol,
  programColLeft,
  buttonColRight
} from '../../index.module.css'

function filterReports(reportFilter, schoolFilter, nodes) {
  if (!reportFilter || reportFilter === '') {
      return nodes.filter( (node) => {
        const upperSchool = node.school.toUpperCase();
        return schoolFilter === 'ALL' || upperSchool === schoolFilter;
    });
  }
  
  return nodes.filter( (node) => {
      const filter = reportFilter.toLowerCase();
      const upperSchool = node.school.toUpperCase();
      const lowerProgramName = node.programName.toLowerCase();
      return lowerProgramName.includes(filter) && (upperSchool === schoolFilter || schoolFilter === 'ALL');
  });
}

const IndexPage = ({ data }) => {
  const nodes = data.allAssessments20222023.nodes
  const [ reportFilter, setReportFilter ] = useState('');
  const [ schoolFilter, setSchoolFilter ] = useState('ALL');

  if (nodes) {
    nodes.sort( (e1, e2) => {
      const n1 = e1;
      const n2 = e2;

      if (n1.school > n2.school) return 1;
      if (n1.school < n2.school) return -1;

      if (n1.programName > n2.programName) return 1;
      if (n1.programName < n2.programName) return -1;

      return 0;
    });
  }

  const filteredReports = filterReports(reportFilter, schoolFilter, nodes);
  
  return (
    <PageLayout>
      <div className={content}>
        <main>
          <div className="pricing-header p-3 pb-md-4 mx-auto text-center">
            <h1 className="display-4 fw-normal">Assessment Reports</h1>
            <p className="fs-5 text-muted">
              Program and General Education Learning Outcomes Assessment
            </p>
          </div>

          <div className="col cp-card-header">
            <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
              <div className="card-header py-3">
                <h4 className="my-0 fw-normal">Assessment Reports for 2022-2023</h4>
              </div>
              <div className="card-body">
                <Search
                  name={'reportFilter'} 
                  onFilterChanged={(e) => setReportFilter(e.target.value)} 
                  onSchoolChanged={(e) => setSchoolFilter(e.target.value)}
                  />
                <Table hover style={{ width: "100% "}}>
                  <tbody>
                    {filteredReports
                      ? filteredReports.map((node, index) => (
                        <tr key={index}>
                          <td className={schoolCol}>
                            {node.school}
                          </td>
                          <td className={programColLeft}>
                            {node.programName}
                            {' '}
                            {node.programSummary && node.programSummary.includes("This program is participating in the Assessment Academy pilot.")
                              ? <Badge bg="light" text="primary">Pilot</Badge>
                              : <></>
                            }
                          </td>
                          <td className={buttonColRight}>
                            <Link
                              to={`${node.reportId}/`}
                              className="btn btn-outline-primary pull-right"
                              role="button">
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                      : <tr><td></td></tr>
                    }
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    allAssessments20222023 {
        nodes {
            id
            school
            programName
            reportId
            programSummary
        }
    }
  }
`
export default IndexPage
